import { TableHead, TableTitle } from '@genial/components';

import { columnWidthsDesktop } from '../constants';

export const Head = () => {
  return (
    <TableHead testId="header">
      <TableTitle textAlign="start" width={columnWidthsDesktop.name} testId="name">
        Nome
      </TableTitle>
      <TableTitle textAlign="start" width={columnWidthsDesktop.email} testId="email">
        E-mail
      </TableTitle>
      <TableTitle
        textAlign="start"
        width={columnWidthsDesktop.personType}
        testId="header-month-competence">
        Pessoa
      </TableTitle>
      <TableTitle
        textAlign="start"
        width={columnWidthsDesktop.sinacorAccount}
        testId="sinacor-account"
        textColor="neutral.medium">
        Conta sinacor
      </TableTitle>
      <TableTitle
        textAlign="start"
        width={columnWidthsDesktop.custodyAccount}
        testId="custody-account">
        Conta de custódia
      </TableTitle>
      <TableTitle textAlign="start" width={columnWidthsDesktop.accountBP} testId="account-bp">
        Conta BP
      </TableTitle>
      <TableTitle textAlign="start" width={columnWidthsDesktop.action} testId="action" />
    </TableHead>
  );
};
